import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Icon, IconName } from 'Components/UI';
import Tooltip from 'Components/UI/Tooltip';
import { GetAvatar, ThumbType } from 'Utils/generateThumbnail';
import { Wrapper } from './styles';

interface IPermissaoUsuarioItem {
  username: string;
  userAvatar?: string;
  userAvatarThumb?: string;
  userAvatarThumbType?: ThumbType;
  privileges: number[];
  hasPlottingPermission?: boolean;
  index: number;
  onChange: (values: any) => void;
}

const buttonsPermissionIcons = ['visualizar', 'download', 'upload', 'editar'];

const PermissaoUsuarioItem: FC<IPermissaoUsuarioItem> = ({
  username,
  userAvatar,
  userAvatarThumb,
  userAvatarThumbType,
  privileges,
  hasPlottingPermission,
  index,
  onChange,
}) => {
  const { t } = useTranslation('editObra');
  const buttonsPermission = [
    t('permissions.permViewer'),
    t('permissions.permDownload'),
    t('permissions.permUpload'),
    t('permissions.permEdit'),
  ];
  const changeHasPlottingPermission = () => {
    onChange({
      privileges,
      index,
      hasPlottingPermission: !hasPlottingPermission
    });
  };

  const changePermissionLevel = (level: number) => {
    if (level !== 0) {
      const permissionIndex = privileges.indexOf(level);
      permissionIndex >= 0
        ? privileges.splice(permissionIndex, 1)
        : privileges.push(level);
      onChange({
        index,
        hasPlottingPermission,
        privileges
      });
    }
  };

  return (
    <Wrapper>
      <div className="container containerUsername">
        <GetAvatar
          name={username}
          shape="circle"
          src={userAvatar}
          thumbSrc={userAvatarThumb}
          thumbType={userAvatarThumbType}
        />
        <span className="username">{username}</span>
      </div>

      {buttonsPermission.map((name, i) => (
        <Tooltip title={name} key={`buttonPermission-${i}`}>
          <div
            className="container containerButton"
            onClick={() => changePermissionLevel(i)}
          >
            <Icon
              icon={buttonsPermissionIcons[i] as IconName}
              customSize={20}
              color={privileges.includes(i) ? 'primary' : 'cinzaPadrao'}
            />
            <p className={privileges.includes(i) ? 'selected' : ''}>
              {name.toLocaleUpperCase()}
            </p>
          </div>
        </Tooltip>
      ))}
      <Tooltip title={t('permissions.tooltipPlotting')}>
        <div
          className="container containerButton"
          onClick={changeHasPlottingPermission}
        >
          <Icon
            icon="menuPlotagem"
            customSize={20}
            color={hasPlottingPermission ? 'primary' : 'cinzaPadrao'}
          />
          <p className={hasPlottingPermission ? 'selected' : ''}>{t('permissions.permPlotting').toUpperCase()}</p>
        </div>
      </Tooltip>
    </Wrapper>
  );
};

export default PermissaoUsuarioItem;
